import ListPageLayout from "../../componets/layout/ListPageLayout";
import bannersApi from "../../services/bannersApi";

export default function Banners() {
    return(

        <ListPageLayout
            title={'Lista Banners'}
            urlCreate={'/banners/formulario'}
            table={
                {
                    loader: bannersApi.all,
                    columns: [
                        { label: "Id", index: "id", type: 'string'},
                        { label: "Nome", index: "nome", type: 'string'},
                    ]
                }
            }
        />
    )
}